import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "fieldRow",
    "comparisonArea",
    "educationSection",
    "careerSection",
    "qualificationSection",
    "deleteCheckbox",
    "deleteFlag",
    "submitButton",
    "errorMessages",
    "educationError",
    "careerError",
    "qualificationError",
    "telephoneInput",
    "telephoneError",
  ];

  connect() {
    this.validateLimits();
  }

  toggleExclude(event) {
    const checkbox = event.target;
    const row = checkbox.closest(
      '[data-resume--auto-fill-confirmation-target="fieldRow"]'
    );
    if (!row) return;

    const comparison = row.querySelector(
      ".mypage-auto-fill-confirmation__comparison"
    );
    if (!comparison) return;

    const deleteFlag = row.querySelector(
      '[data-resume--auto-fill-confirmation-target="deleteFlag"]'
    );

    if (checkbox.checked) {
      comparison.classList.add("is-excluded");
      if (deleteFlag) deleteFlag.value = "1";
    } else {
      comparison.classList.remove("is-excluded");
      if (deleteFlag) deleteFlag.value = "0";
    }

    this.validateLimits();
  }

  validateLimits() {
    const errors = [];

    if (this.hasEducationSectionTarget) {
      const totalRows = this.countTotalRows(this.educationSectionTarget);
      const activeCount = this.countActiveRows(this.educationSectionTarget);

      if (totalRows > 3) {
        this.showDeleteCheckboxes(this.educationSectionTarget);
      }

      let educationError = "";
      if (activeCount > 3) {
        educationError =
          "学歴は「削除する」を設定し、3件以内に減らしてください。";
      } else if (this.hasEmptyNameInSection(this.educationSectionTarget, "school_name")) {
        educationError = "学校名を入力してください。";
      }

      if (educationError) {
        errors.push(educationError);
        if (this.hasEducationErrorTarget) {
          this.educationErrorTarget.textContent = educationError;
          this.educationErrorTarget.style.display = "";
        }
      } else {
        if (this.hasEducationErrorTarget) {
          this.educationErrorTarget.textContent = "";
          this.educationErrorTarget.style.display = "none";
        }
      }
    }

    if (this.hasCareerSectionTarget) {
      const totalRows = this.countTotalRows(this.careerSectionTarget);
      const activeCount = this.countActiveRows(this.careerSectionTarget);

      if (totalRows > 3) {
        this.showDeleteCheckboxes(this.careerSectionTarget);
      }

      let careerError = "";
      if (activeCount > 3) {
        careerError =
          "職歴は「削除する」を設定し、3件以内に減らしてください。";
      } else if (this.hasEmptyNameInSection(this.careerSectionTarget, "[title]")) {
        careerError = "会社・案件名を入力してください。";
      }

      if (careerError) {
        errors.push(careerError);
        if (this.hasCareerErrorTarget) {
          this.careerErrorTarget.textContent = careerError;
          this.careerErrorTarget.style.display = "";
        }
      } else {
        if (this.hasCareerErrorTarget) {
          this.careerErrorTarget.textContent = "";
          this.careerErrorTarget.style.display = "none";
        }
      }
    }

    if (this.hasQualificationSectionTarget) {
      const totalRows = this.countTotalRows(this.qualificationSectionTarget);
      const activeCount = this.countActiveRows(this.qualificationSectionTarget);

      if (totalRows > 20) {
        this.showDeleteCheckboxes(this.qualificationSectionTarget);
      }

      if (activeCount > 20) {
        errors.push(
          "資格は「削除する」を設定し、20件以内に減らしてください。"
        );
        if (this.hasQualificationErrorTarget) {
          this.qualificationErrorTarget.textContent =
            "資格は「削除する」を設定し、20件以内に減らしてください。";
          this.qualificationErrorTarget.style.display = "";
        }
      } else {
        if (this.hasQualificationErrorTarget) {
          this.qualificationErrorTarget.textContent = "";
          this.qualificationErrorTarget.style.display = "none";
        }
      }
    }

    if (this.hasTelephoneInputTarget) {
      const input = this.telephoneInputTarget;
      const telephoneInvalid = !input.checkValidity();
      const message = telephoneInvalid ? input.validationMessage : "";

      if (telephoneInvalid) {
        errors.push(message);
      }

      if (this.hasTelephoneErrorTarget) {
        if (telephoneInvalid) {
          this.telephoneErrorTarget.textContent = message;
          this.telephoneErrorTarget.style.display = "";
        } else {
          this.telephoneErrorTarget.textContent = "";
          this.telephoneErrorTarget.style.display = "none";
        }
      }
    }

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = errors.length > 0;
    }

    if (this.hasErrorMessagesTarget) {
      if (errors.length > 0) {
        this.errorMessagesTarget.textContent = errors.join("　");
        this.errorMessagesTarget.style.display = "";
      } else {
        this.errorMessagesTarget.textContent = "";
        this.errorMessagesTarget.style.display = "none";
      }
    }
  }

  countTotalRows(section) {
    return section.querySelectorAll(
      '[data-resume--auto-fill-confirmation-target="fieldRow"]'
    ).length;
  }

  countActiveRows(section) {
    const rows = section.querySelectorAll(
      '[data-resume--auto-fill-confirmation-target="fieldRow"]'
    );
    let count = 0;
    rows.forEach((row) => {
      const comparison = row.querySelector(
        ".mypage-auto-fill-confirmation__comparison"
      );
      if (comparison && !comparison.classList.contains("is-excluded")) {
        count++;
      }
    });
    return count;
  }

  hasEmptyNameInSection(section, nameKey) {
    const rows = section.querySelectorAll(
      '[data-resume--auto-fill-confirmation-target="fieldRow"]'
    );
    let found = false;
    rows.forEach((row) => {
      const comparison = row.querySelector(
        ".mypage-auto-fill-confirmation__comparison"
      );
      if (comparison && !comparison.classList.contains("is-excluded")) {
        const input = row.querySelector(`input[name*="${nameKey}"]`);
        if (input && !input.value.trim()) {
          found = true;
        }
      }
    });
    return found;
  }

  showDeleteCheckboxes(section) {
    const checkboxes = section.querySelectorAll(
      '[data-resume--auto-fill-confirmation-target="deleteCheckbox"]'
    );
    checkboxes.forEach((cb) => {
      cb.style.display = "";
    });
  }
}
